import Vue from 'vue';
import { gsap } from 'gsap/all';

Vue.component('project-filter-component', {
    data() {
        return {
            popupVisible: false,
        };
    },

    props: {
        projectTypes: {
            type: Array,
            default: [],
            shadowOverlay: null,
            isAnimating: false,
        },
    },

    mounted() {
        this.shadowOverlay = document.querySelector('.projects__shadow');

        gsap.to('.project-filter__holder', {
            duration: 1.8, autoAlpha: 1, delay: 1.4, ease: 'power4.out',
        });

        EventBus.$on('toggle-filter', () => {
            this.togglePopup();
        });
    },

    methods: {
        togglePopup() {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            const tl = gsap.timeline({
                onComplete: () => {
                    this.isAnimating = false;
                },
            });

            if (!this.popupVisible) {
                this.popupVisible = true;
                EventBus.$emit('project-shadow-toggle', true);

                gsap.set('.project-filter__popup-inner span', {
                    y: 20,
                    autoAlpha: 0,
                });

                gsap.set('.project-filter__popup-close', {
                    autoAlpha: 0,
                });

                // Start timeline
                tl.to(this.shadowOverlay, {
                    duration: 0.8,
                    autoAlpha: 0.8,
                    ease: 'power2.inOut',
                }, 0);

                tl.to(this.$refs.popup, {
                    height: 'auto',
                    duration: 1,
                    ease: 'power4.inOut',
                }, 0);

                tl.to('.project-filter__popup-close', {
                    autoAlpha: 1,
                    duration: 1,
                }, '<');

                tl.to('.project-filter__popup-inner span', {
                    autoAlpha: 1,
                    stagger: -0.1,
                    duration: 0.4,
                    ease: 'power1.inOut',
                }, 0.35);

                tl.to('.project-filter__popup-inner span', {
                    y: 0,
                    stagger: -0.1,
                    duration: 0.4,
                    ease: 'power2.inOut',
                }, 0.35);

                return;
            }

            tl.to(this.$refs.popup, {
                height: 0,
                duration: 0.8,
                ease: 'power4.inOut',
                onComplete: () => {
                    this.popupVisible = false;
                },
            }, 0);

            tl.to(['.project-filter__popup-inner span', '.project-filter__popup-close'], {
                duration: 0.6,
                autoAlpha: 0,
            }, '<');

            tl.to(this.shadowOverlay, {
                autoAlpha: 0,
                duration: 0.6,
                ease: 'power2.inOut',
                onComplete: () => {
                    EventBus.$emit('project-shadow-toggle', false);
                },
            }, 0);
        },
    },
});
